import { Autocomplete, Box, Button, FormControlLabel, Grid, IconButton, Modal, Paper, Radio, RadioGroup, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Colors } from '../../Styles/Colors';
import { ImagePaths } from '../../Utility/ImagePaths';
import CancelTwoToneIcon from '@mui/icons-material/CancelTwoTone';
import { CommonGridToolBarWithExtraFilter, CommonPatientDetails, DeletePopup, OpenWebCamPopUP } from '../../Components/Common Components/CommonComponents';
import { getCachevalue, localGetItem } from '../../Utility/Services/CacheProviderService';
import { DataGrid } from '@mui/x-data-grid';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ToastMsg from '../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../Utility/API/Serviceurls';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { DateTime } from 'luxon';
import { dataURItoFile, debounce } from '../../Components/CommonFunctions/CommonFunctions';
import { FileDownload, InfoOutlined, VisibilityOutlined } from '@mui/icons-material';

const MRD_DOCUMENT_MAX_FILE_BYTES = 5 * 1024 * 1024;
const MRD_DOCUMENT_OVERSIZE_MESSAGE = 'Uploading files larger than 5MB is not allowed.';

const MrdDocumentsAdd = (props) => {
  let patientData = getCachevalue("MRDpatientDetails") ? getCachevalue("MRDpatientDetails") : null
  const [errorMsg, seterrorMsg] = useState(false);
  const [errorMsgText, seterrorMsgText] = useState('');
  const [successMsg, setsuccessMsg] = useState(false);
  const [successMsgText, setsuccessMsgText] = useState('');
  const [CategoryList, setCategoryList] = useState([]);
  const [LocationList, setLocationList] = useState([]);
  const [patientDetails, setpatientDetails] = useState(patientData ? JSON.parse(patientData) : null);
  const [selectedCategory, setselectedCategory] = useState(null);
  const [selectedLocation, setselectedLocation] = useState(null);
  const [docuName, setDocuName] = useState("");
  const [medicoLegel, setmedicoLegel] = useState("no");
  const [visitDate, setVisitDate] = useState(null);
  const [DocumentsList, setDocumentsList] = useState([]);
  const [documentType, setDocumentType] = useState(null);
  const [icdCodeSearch, setIcdCodeSearch] = useState('');
  const [codeICDapi, setCodeICDapi] = useState([]);
  const [selectedIcd, setSelectedIcd] = useState(null);
  const [documentRemarks, setDocumentRemarks] = useState('');
  const [isloader, setisloader] = useState(false);
  const [isDelete, setisDelete] = useState(false);
  const [deletedID, setdeletedID] = useState(null);
  const [searchDoc, setSearchDoc] = useState(null);

  const [Image, setImage] = useState(
    {
      open: false,
      imageuploadList: [],
      imageViewerPopup: false,
      viewData: [],
      viewImage: null,
      selectedImage: null,
      imgCapClked: false,
      CapturedImg: null,
      currentIndex: 0,
    }
  );

  const uploadImage = useRef(null);

  const debouncedIcdSearch = useMemo(
    () =>
      debounce((searchKey) => {
        try {
          const UserData = JSON.parse(localGetItem('loggedInUserInfo') || '{}');
          if (!searchKey || String(searchKey).trim() === '') {
            setCodeICDapi([]);
            return;
          }
          const clinicQ = UserData?.clinic_id ? `&clinic_id=${UserData.clinic_id}` : '';
          RestAPIService.getAll(
            `${Serviceurls.GET_ICD_CODE}?search_key=${encodeURIComponent(searchKey)}${clinicQ}`
          )
            .then((response) => {
              if (response.data.status === 'success') {
                setCodeICDapi(response.data?.data || []);
              }
            })
            .catch(() => {
              setCodeICDapi([]);
            });
        } catch (e) {
          setCodeICDapi([]);
        }
      }, 500),
    []
  );

  const DocTypeList = [
    { name: 'Out Patient', value: 'op' },
    { name: 'In Patient', value: 'ip' }
  ]

  useEffect(() => {
    getCategoryMaster()
    getDocumentsList()
  }, [])

  const errorMessage = (msg) => {
    seterrorMsgText(msg)
    seterrorMsg(true)
  }

  const successMessage = (msg) => {
    setsuccessMsgText(msg)
    setsuccessMsg(true)
  }

  const msgClose = () => {
    seterrorMsg(false);
    seterrorMsgText('');
    setsuccessMsg(false);
    setsuccessMsgText('');
  }

  const getCategoryMaster = () => {
    try {
      setisloader(true)
      RestAPIService.getAll(Serviceurls.MRD_CATEGORY_GET_POST)
        .then((response) => {
          if (response.data.status === 'success') {
            let Data = response?.data?.data || [];
            let FilteredData = Data.filter(item => item.is_active === true)
            setCategoryList(FilteredData || [])
            setisloader(false)
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      setisloader(false)
      errorMessage(e.message)
    }
  }

  /** Rack id from patient documents (any row may carry rack_id; not only index 0). */
  const resolvePatientRackIdFromDocuments = (documents) => {
    if (!documents?.length) return null;
    const doc = documents.find(
      (d) => d?.rack_id != null && d?.rack_id !== '' && String(d.rack_id).trim() !== ''
    );
    return doc ? doc.rack_id : null;
  };

  /**
   * patientDocuments: latest list from getDocumentsList — used to resolve rack label/id
   * before merging with occupied-status API (existing patient keeps their rack even if occupied).
   */
  const getLocationMaster = (rackID, patientDocuments = null) => {
    try {
      setisloader(true)
      RestAPIService.getAll(Serviceurls.MRD_RACK_OCCUPIED_STATUS)
        .then((response) => {
          if (response.data.status === 'success') {
            const raw = response?.data?.data || [];
            const normalized = raw.map((item) => ({
              ...item,
              id: item.rack_id,
            }));

            const hasExistingRack =
              rackID != null && rackID !== '' && String(rackID).trim() !== '';

            let preSelected = null;
            if (hasExistingRack) {
              preSelected = normalized.find(
                (item) =>
                  String(item.rack_id) === String(rackID) ||
                  String(item.id) === String(rackID)
              );

              if (!preSelected && patientDocuments?.length) {
                const doc = patientDocuments.find(
                  (d) => String(d?.rack_id) === String(rackID)
                );
                if (doc) {
                  preSelected = {
                    rack_id: doc.rack_id,
                    id: doc.rack_id,
                    rack_code: doc.rack_code ?? '',
                    rack_name:
                      (doc.rack_name != null && String(doc.rack_name).trim() !== '')
                        ? doc.rack_name
                        : `Rack ${doc.rack_id}`,
                    is_occupied: true,
                  };
                } else {
                  preSelected = {
                    rack_id: rackID,
                    id: rackID,
                    rack_code: '',
                    rack_name: `Rack ${rackID}`,
                    is_occupied: true,
                  };
                }
              } else if (!preSelected) {
                preSelected = {
                  rack_id: rackID,
                  id: rackID,
                  rack_code: '',
                  rack_name: `Rack ${rackID}`,
                  is_occupied: true,
                };
              }
            }

            let list = normalized.filter((r) => r.is_occupied === false);

            if (
              preSelected &&
              !list.some((r) => String(r.rack_id) === String(preSelected.rack_id))
            ) {
              list = [...list, preSelected];
            }

            setLocationList(list);
            setselectedLocation(hasExistingRack ? preSelected : null);
            setisloader(false)
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      setisloader(false)
      errorMessage(e.message)
    }
  }

  const getDocumentsList = (DocType) => {
    try {
      setisloader(true)
      RestAPIService.getAll(Serviceurls.MRD_DOCUMENTS_ADD + `?patient_id=${patientDetails?.patient_id || null}&document_type=${DocType?.value || ''}`)
        .then((response) => {
          if (response.data.status === 'success') {
            const documents = response?.data?.documents || [];
            setDocumentsList(documents);
            const selectedRack = resolvePatientRackIdFromDocuments(documents);
            getLocationMaster(selectedRack, documents);
            setisloader(false)
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      setisloader(false)
      errorMessage(e.message)
    }
  }

  const PopupClose = () => {
    setisDelete(false);
    setdeletedID(null)
  }

  const deletePatientDocument = () => {
    try {
      RestAPIService.delete(Serviceurls.MRD_DOCUMENTS_ADD + `?id=${deletedID || null}`)
        .then((response) => {
          if (response.data.status === 'success') {
            successMessage(response.data.message)
            getDocumentsList()
            setdeletedID(null);
            setisDelete(false)
          }
        }).catch(e => {
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const getS3Key = async (doc_key, id) => {
    try {
      const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(doc_key));

      if (response.data.status === "success") {
        const Data = response.data;
        return {
          data_url: Data.data
        };
      }
    } catch (e) {
      setisloader(false)
      errorMessage("Error fetching S3 URL")
    }
  }

  const triggerDownloadFromUrl = async (url, fileName) => {
    try {
      const res = await fetch(url, { mode: 'cors', credentials: 'omit' });
      if (!res.ok) throw new Error('Download failed');
      const blob = await res.blob();
      const objectUrl = URL.createObjectURL(blob);
      try {
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = fileName || 'document.pdf';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } finally {
        URL.revokeObjectURL(objectUrl);
      }
    } catch (e) {
      errorMessage(e?.message || 'Could not download file.');
    }
  };

  const renderImage = async (imageData, pdfData) => {
    let tempArr = [];

    if (imageData.length > 0) {
      for (let i = 0; i < imageData.length; i++) {
        let image = imageData[i];
        if (image !== null) {
          let doc_key = image;
          let getData = await getS3Key(doc_key); // make sure this is a top-level async function
          getData["type"] = image.split('.').pop() === "pdf" ? "pdf" : "image";
          tempArr.push(getData);
        }
      }
    }

    if (pdfData && tempArr[0]?.data_url) {
      const firstKey = imageData.find((im) => im != null);
      const fileName = firstKey ? String(firstKey).split('/').pop() : 'document.pdf';
      await triggerDownloadFromUrl(tempArr[0].data_url, fileName || 'document.pdf');
    }

    setImage((prev) => ({
      ...prev,
      viewData: tempArr,
      viewImage: tempArr[0],
    }));
  };

  const onImageHandler = async (e) => {
    const imageList = [];
    let imageFiles = [...e.target.files];

    let clearedArr = imageFiles?.filter((image, i) => {
      let file = image?.name;
      return String(file).toLowerCase() !== String(imageFiles[i + 1]?.name).toLowerCase();
    });

    const oversizeFiles = clearedArr.filter((f) => f.size > MRD_DOCUMENT_MAX_FILE_BYTES);
    const validFiles = clearedArr.filter((f) => f.size <= MRD_DOCUMENT_MAX_FILE_BYTES);

    if (oversizeFiles.length > 0) {
      errorMessage(MRD_DOCUMENT_OVERSIZE_MESSAGE);
    }

    for (let i = 0; i < validFiles.length; i++) {
      imageList.push(validFiles[i]);
    }

    const newList = await Promise.all(imageList);

    setImage((prev) => ({
      ...prev,
      imageuploadList: [...prev.imageuploadList, ...newList],
    }));

    e.target.value = '';
  };

  const onImageRemove = (index) => {
    setImage((prev) => {
      const updatedList = [...prev.imageuploadList];
      updatedList.splice(index, 1);
      return {
        ...prev,
        imageuploadList: updatedList,
      };
    });
  };

  const prevImage = (index) => {
    let currentIndex = parseInt(index) || 0;

    if (currentIndex >= 1) {
      setImage((prev) => ({
        ...prev,
        currentIndex: currentIndex - 1,
        viewImage: prev.viewData[currentIndex - 1],
      }));
    }
  };

  const nextImage = (index) => {
    let currentIndex = parseInt(index) || 0;

    if (currentIndex + 1 < Image.viewData.length) {
      setImage((prev) => ({
        ...prev,
        currentIndex: currentIndex + 1,
        viewImage: prev.viewData[currentIndex + 1],
      }));
    }
  };

  const renderImageViewerPopup = () => {
    try {
      if (Image.viewData?.length > 0) {
        return (
          <Box component={'div'}>
            <Modal open={Image.imageViewerPopup}>
              <Box className='eMed_Doc_Img_Pop_Up'>
                <Box component={'div'} height={'2.5vw'} display={'flex'} pl={'1vw'} alignItems={'center'} justifyContent={'space-between'}>
                  <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>
                    MRD Documents
                  </Typography>
                  <Button
                    onClick={() =>
                      setImage((prev) => ({
                        ...prev,
                        imageViewerPopup: false,
                      }))
                    }
                  >
                    <Box
                      component={'img'}
                      src={ImagePaths.LabCloseButton.default}
                      height={'1vw'}
                      width={'1vw'}
                      mr={'1vw'}
                    />
                  </Button>
                </Box>

                <Box height={'30vw'} display={'flex'} justifyContent={'center'}>
                  {Image.viewData?.length > 1 && (
                    <Box component={'div'} display={'flex'} alignItems={'center'}>
                      <Button
                        size="small"
                        className="Common_Btn_Min_Width"
                        sx={{ height: '3vw' }}
                        onClick={() => prevImage(Image.currentIndex)}
                      >
                        <KeyboardDoubleArrowLeftIcon className="eMed_testrp_arrowSize" fontSize="large" color="primary" />
                      </Button>
                    </Box>
                  )}

                  {Image.viewImage?.type === 'pdf' ? (
                    <Box>
                      <img
                        style={{ width: '12vw', height: '12vw' }}
                        src={ImagePaths.DocumentPreview.default}
                        alt="slide"
                      />
                      <Button variant="contained" onClick={() => window.open(Image.viewImage?.data_url)}>
                        Download Document
                      </Button>
                    </Box>
                  ) : (
                    <Box component={'div'} height={'30vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                      <img
                        src={Image.viewImage?.data_url || ''}
                        alt="slide"
                        style={{ objectFit: 'contain', height: '15vw', width: '30vw' }}
                      />
                    </Box>
                  )}

                  {Image.viewData?.length > 1 && (
                    <Box component={'div'} display={'flex'} alignItems={'center'}>
                      <Button
                        size="small"
                        className="Common_Btn_Min_Width"
                        sx={{ height: '3vw' }}
                        onClick={() => nextImage(Image.currentIndex)}
                      >
                        <KeyboardDoubleArrowRightIcon className="eMed_testrp_arrowSize" fontSize="large" color="primary" />
                      </Button>
                    </Box>
                  )}
                </Box>
              </Box>
            </Modal>
          </Box>
        );
      }
      return null;
    } catch (error) {
      errorMessage(error?.message)
    }
  };

  const closeWebCamPop = () => {
    setImage((prev) => ({
      ...prev,
      imgCapClked: false,
      CapturedImg: null,
    }));
  };

  const addImgCapture = (data) => {
    if (data) {
      const capturedFile = dataURItoFile(data, `report_file_${Date.now()}.jpg`);
      if (capturedFile.size > MRD_DOCUMENT_MAX_FILE_BYTES) {
        errorMessage(MRD_DOCUMENT_OVERSIZE_MESSAGE);
        return;
      }
      setImage((prev) => ({
        ...prev,
        imageuploadList: [
          ...prev.imageuploadList,
          capturedFile
        ],
        imgCapClked: false,
      }));
    }
  };

  const UploadButton = (onClick, imgSrc, text) => {
    return (
      <Button sx={{ textTransform: "capitalize" }}
        disabled={Image.imageuploadList?.length === 6}
        onClick={onClick}
      >
        <Box
          component="div"
          borderRadius="10px"
          border="1px dotted gray"
          height="10vw"
          width="12vw"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Box component="img" src={imgSrc} height="2vw" width="2vw" />
          <Typography fontSize="0.9vw" color={Colors.SecondaryText} fontWeight={600} mt="0.5vw">
            {Image.imageuploadList.length === 6 ? ("MaxUpload") : text}
          </Typography>
        </Box>
      </Button>
    );
  };


  const renderLeftSide = () => {
    try {
      const gridToolBar = () => {
        return (
          <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
            <Autocomplete
              size='small'
              options={DocTypeList}
              sx={{ width: '18dvw', marginLeft: "0.5vw" }}
              getOptionLabel={(option) => typeof (option) === 'string' ? option : option.name}
              value={searchDoc}
              onChange={(e, value) => {
                setSearchDoc(value)
                getDocumentsList(value)
              }}
              renderInput={(params) => <TextField autoComplete='off' {...params} label={"Select Document Type"} />}
            />
            <CommonGridToolBarWithExtraFilter />
          </Box>
        )
      }
      DocumentsList?.forEach((element, index) => element.sno = index + 1)
      const columns = [
        {
          field: 'document_name', headerName: 'Document Name', flex: 0.075,
          renderCell: (params) => (params.row.document_name ? params.row.document_name?.length > 35 ?
            <Tooltip placement="top" title={params.row.document_name}><Typography fontSize={'0.9vw'}>{params.row.document_name?.slice(0, 32) + '...'}</Typography></Tooltip> :
            <Typography fontSize={'0.9vw'}>{params.row.document_name || '-'}</Typography> : '-')
        },
        {
          field: 'uploaded_date', headerName: 'Uploaded Date', flex: 0.045, headerAlign: 'center', align: "center",
          renderCell: (params) => (<Box component={'div'}>{params?.row?.uploaded_date ? (params?.row?.uploaded_date).split('-').reverse().join('-') : '-'}</Box>)
        },
        {
          field: 'visit_date', headerName: 'Visit Date', flex: 0.045, headerAlign: 'center', align: "center",
          renderCell: (params) => (<Box component={'div'}>{params?.row?.visit_date ? (params?.row?.visit_date).split('-').reverse().join('-') : '-'}</Box>)
        },
        {
          field: 'document_type', headerName: 'Document Type', flex: 0.04,
          renderCell: (params) => (<Box component={'div'} fontWeight={600} textTransform={'uppercase'}>{params?.row?.document_type || '-'}</Box>)
        },
        {
          field: 'icd_code',
          headerName: 'ICD Code',
          flex: 0.05,
          renderCell: (params) => {
            const row = params.row;
            const code = row?.icd_code;
            if (!code) {
              return <Typography fontSize={'0.9vw'}>-</Typography>;
            }
            const shortD = row?.icd_short_desc ?? '';
            const longD = row?.icd_long_desc ?? row?.icd_desc ?? '';
            const remarks = row?.remarks ?? '';
            const codeLine = [code, shortD, longD].filter((p) => p != null && String(p).trim() !== '').join(' | ');
            return (
              <Tooltip
                placement="top"
                arrow
                componentsProps={{ tooltip: { sx: { maxWidth: 440 } } }}
                title={
                  <Box sx={{ py: 0.25 }}>
                    <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', fontSize: '0.8rem' }}>
                      {codeLine}
                    </Typography>
                  </Box>
                }
              >
                <Typography fontSize={'0.9vw'}>
                  {code}
                </Typography>
              </Tooltip>
            );
          },
        },
        {
          field: 'ver_no', headerName: 'Version No', flex: 0.03,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.ver_no || '0'}</Box>)
        },
        {
          field: 'is_medico_legal', headerName: 'Medico Legal', flex: 0.035,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.is_medico_legal ? 'Yes' : 'No'}</Box>)
        },
        {
          field: 'action',
          headerName: 'Action',
          flex: 0.055,
          headerAlign: 'center',
          align: 'center',
          disableExport: true,
          renderCell: (params) => {
            const row = params.row;
            const hasRemarks = row?.remarks != null && String(row.remarks).trim() !== '';
            const firstKey = row?.doc_key?.[0];
            const isPdf = typeof firstKey === 'string' && firstKey.toLowerCase().includes('.pdf');
            const docKeys = row?.doc_key || [];

            const actionSlotSx = {
              width: 30,
              minWidth: 30,
              maxWidth: 30,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              marginLeft: -0.5,
            };
            const middleSlotSx = {
              width: 40,
              minWidth: 40,
              maxWidth: 40,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              marginLeft: -2,
            };

            return (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                  minHeight: 40,
                  gap: 0.25,
                  marginLeft: -2,
                  marginRight: -0.5,
                }}
              >
                <Box sx={actionSlotSx}>
                  {hasRemarks ? (
                    <Tooltip
                      placement="top"
                      arrow
                      componentsProps={{ tooltip: { sx: { maxWidth: 420 } } }}
                      title={
                        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', fontSize: '0.8rem' }}>
                          {row.remarks}
                        </Typography>
                      }
                    >
                      <IconButton size="small" sx={{ p: 0.5, marginRight:'1vw' }} aria-label="View remarks">
                        <InfoOutlined sx={{ fontSize: '1.25rem' }} color="primary" />
                      </IconButton>
                    </Tooltip>) : null}
                </Box>

                <Box sx={middleSlotSx}>
                  {isPdf ? (
                    <Tooltip title="Download Document" placement="top" arrow>
                      <span>
                        <IconButton
                          size="small"
                          sx={{ p: 0.5 }}
                          aria-label="Download document"
                          onClick={() => {
                            if (docKeys.length > 0) {
                              setImage((prev) => ({
                                ...prev,
                                viewData: [],
                                viewImage: null,
                              }));
                              renderImage(docKeys, true);
                            } else {
                              errorMessage('No PDF to be view');
                            }
                          }}
                        >
                          <FileDownload color="primary" sx={{ fontSize: '1.25rem' }} />
                        </IconButton>
                      </span>
                    </Tooltip>
                  ) : (
                    <Tooltip title="View Document" placement="top" arrow>
                      <span>
                        <IconButton
                          size="small"
                          sx={{ p: 0.5 }}
                          aria-label="View document"
                          onClick={() => {
                            if (docKeys.length > 0) {
                              setImage((prev) => ({
                                ...prev,
                                imageViewerPopup: true,
                                viewOpen: true,
                                viewData: [],
                                viewImage: null,
                              }));
                              renderImage(docKeys);
                            } else {
                              errorMessage('No image to be view');
                            }
                          }}
                        >
                          <VisibilityOutlined color="primary" sx={{ fontSize: '1.25rem' }} />
                        </IconButton>
                      </span>
                    </Tooltip>
                  )}
                </Box>

                <Box sx={actionSlotSx}>
                  {props?.Access?.editAccess ? (
                    <Tooltip title="Delete Document" placement="top" arrow>
                      <IconButton
                        size="small"
                        sx={{ p: 0.5 }}
                        className="eMed_usrconf_btn"
                        emed_tid="PO_requestList_print"
                        onClick={() => {
                          setisDelete(true);
                          setdeletedID(row?.document_id);
                        }}
                        aria-label="Delete document"
                      >
                        <Box
                          component="img"
                          src={ImagePaths.LabDeleteButton.default}
                          alt=""
                          sx={{ width: '1.35rem', height: '1.35rem' }}
                        />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                </Box>
              </Box>
            );
          },
        },
      ];
      return (
        <Box sx={{ height: '69vh', marginTop: '.5vw', backgroundColor: 'white' }}>
          <DataGrid
            rows={DocumentsList}
            columns={columns}
            getRowId={(row) => row['sno']}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            hideFooter={true}
            components={{
              Toolbar: gridToolBar,
              NoRowsOverlay: () => (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  {'No Records To Be Shown'}
                </Box>
              )
            }}
            headerHeight={40}
            density='standard'
            disableSelectionOnClick
            loading={isloader}
          />
        </Box>
      )
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const postDocuments = () => {
    const UserData = JSON.parse(localGetItem('loggedInUserInfo'))

    if (!selectedCategory || !selectedLocation || !documentType || !visitDate) {
      errorMessage("Please enter mandatory fields");
      return;
    }
    const validVistiDate = DateTime.fromJSDate(
      visitDate instanceof Date ? visitDate : new Date(visitDate)
    );
    if (!validVistiDate.isValid) {
      errorMessage("Please select correct date");
      return;
    }
    const today = DateTime.now().startOf('day');
    if (validVistiDate.startOf('day') > today) {
      errorMessage("Visit date cannot be in the future");
      return;
    }
    if (!docuName?.trim()) {
      errorMessage("Enter a Document Name");
      return;
    }
    if (Image.imageuploadList.length <= 0) {
      errorMessage("Upload atleast one Image");
      return;
    }
    const hasOversizeFile = Image.imageuploadList.some(
      (f) => f && typeof f.size === 'number' && f.size > MRD_DOCUMENT_MAX_FILE_BYTES
    );
    if (hasOversizeFile) {
      errorMessage(MRD_DOCUMENT_OVERSIZE_MESSAGE);
      return;
    }
    try {
      const dataForm = new FormData();
      dataForm.append('patient_id', patientDetails?.patient_id || null);
      dataForm.append('category_id', selectedCategory ? selectedCategory?.id : null);
      dataForm.append('rack_id', selectedLocation ? selectedLocation?.id : null);
      dataForm.append('document_name', docuName || '');
      dataForm.append('is_medico_legal', medicoLegel || 'no');
      dataForm.append('visit_date', validVistiDate.toFormat('yyyy-MM-dd'))
      dataForm.append('document_type', documentType?.value || null);
      dataForm.append('icd_code', selectedIcd?.icd_code ?? '');
      dataForm.append('remarks', (documentRemarks || '').slice(0, 1500));
      dataForm.append('clinic_id', UserData?.clinic_id || null);
      for (let i = 0; i < Image.imageuploadList.length; i++) {
        dataForm.append('doc_key', Image.imageuploadList[i])
      }

      setisloader(true)
      RestAPIService.create(dataForm, Serviceurls.MRD_DOCUMENTS_ADD)
        .then((response) => {
          if (response.data.status === 'success') {
            successMessage(response.data.message)
            setisloader(false)
            setselectedCategory(null)
            setselectedLocation(null)
            setDocuName("")
            setVisitDate(null)
            setDocumentType(null)
            setSelectedIcd(null)
            setIcdCodeSearch('')
            setCodeICDapi([])
            setDocumentRemarks('')
            setmedicoLegel("no")
            getDocumentsList()
            setImage(prev => ({
              ...prev,
              open: false,
              imageuploadList: [],
              imageViewerPopup: false,
              viewData: [],
              viewImage: null,
              selectedImage: null,
              imgCapClked: false,
              CapturedImg: null,
            }))
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      setisloader(false)
      errorMessage(e.message)
    }
  }

  const renderRightSide = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          minHeight: 0,
          overflow: 'hidden',
        }}
      >
        <Typography className='eMed_refdoc_title' sx={{ flexShrink: 0 }}>
          {"Patient Documents"}
        </Typography>
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
            py: 0.5,
            pr: 0.5,
          }}
        >
          <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-around', gap: 1 }}>
            <Autocomplete
              clearIcon
              size='small'
              options={CategoryList}
              sx={{ width: '14dvw' }}
              getOptionLabel={(option) => typeof (option) === 'string' ? option : option.category_name}
              value={selectedCategory}
              onChange={(e, value) => {
                setselectedCategory(value)
              }}
              renderInput={(params) => <TextField autoComplete='off' {...params} label={"Select Category *"} />}
            />
            <Autocomplete
              clearIcon
              size='small'
              sx={{ width: '14vw' }}
              options={LocationList}
              getOptionLabel={(option) => typeof (option) === 'string' ? option : option.rack_name}
              value={selectedLocation}
              onChange={(e, value) => {
                setselectedLocation(value)
              }}
              renderInput={(params) => <TextField autoComplete='off' {...params} label={"Select Rack *"} />}
            />
            <TextField
              size='small'
              sx={{ width: "14dvw" }}
              value={docuName}
              label={"Document Name *"}
              autoComplete='off'
              inputProps={{ maxLength: 50 }}
              onChange={(e) => {
                setDocuName(e.target.value)
              }}
            />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={visitDate}
                inputFormat='DD-MM-YYYY'
                label={"Select Visit Date *"}
                maxDate={new Date()}
                onChange={
                  (newDate) => {
                    if (newDate == null) {
                      setVisitDate(new Date());
                    } else {
                      setVisitDate(newDate);
                    }
                  }}
                renderInput={(params) => <TextField style={{ width: '14dvw' }} size='small' {...params} />}
              />
            </LocalizationProvider>
            <Autocomplete
              clearIcon
              size='small'
              options={DocTypeList}
              sx={{ width: '29dvw' }}
              getOptionLabel={(option) => typeof (option) === 'string' ? option : option.name}
              value={documentType}
              onChange={(e, value) => {
                setDocumentType(value)
              }}
              renderInput={(params) => <TextField autoComplete='off' {...params} label={"Select Document Type *"} />}
            />
            <Autocomplete
              clearIcon
              size='small'
              sx={{ width: '29dvw' }}
              options={codeICDapi}
              filterOptions={(options) => options}
              value={selectedIcd}
              inputValue={icdCodeSearch}
              onInputChange={(e, newInputValue, reason) => {
                if (reason === 'reset') {
                  return;
                }
                setIcdCodeSearch(newInputValue);
                if (reason === 'clear') {
                  setCodeICDapi([]);
                  setSelectedIcd(null);
                  return;
                }
                if (reason === 'input' && newInputValue) {
                  debouncedIcdSearch(newInputValue);
                }
                if (reason === 'input' && !newInputValue) {
                  setCodeICDapi([]);
                  setSelectedIcd(null);
                }
              }}
              noOptionsText={icdCodeSearch === '' ? 'Please enter to search' : 'No data found'}
              isOptionEqualToValue={(option, value) =>
                !!option && !!value && String(option.icd_code) === String(value.icd_code)
              }
              getOptionLabel={(option) => {
                if (!option || typeof option === 'string') return '';
                return `${option.icd_code || ''} | ${option.icd_short_desc || ''} | ${option.icd_desc || ''}`;
              }}
              onChange={(e, value) => {
                setSelectedIcd(value);
                if (value) {
                  setIcdCodeSearch(
                    `${value.icd_code || ''} | ${value.icd_short_desc || ''} | ${value.icd_desc || ''}`
                  );
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  autoComplete='off'
                  label="ICD Code"
                  placeholder="Enter ICD Code / Short Description / Long Description"
                />
              )}
            />
          </Box>
          <TextField
            size='small'
            fullWidth
            sx={{ mt: 1, px: 0.5 }}
            label="Remarks"
            multiline
            minRows={3}
            maxRows={8}
            value={documentRemarks}
            autoComplete='off'
            inputProps={{ maxLength: 1500 }}
            onChange={(e) => setDocumentRemarks(e.target.value)}
          />
          <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
            <Typography sx={{ marginLeft: "0.5vw", marginRight: "1vw" }}>Medico Legal</Typography>
            <RadioGroup
              row
              value={medicoLegel}
              onChange={(e) => {
                setmedicoLegel(e.target.value)
              }}
            >
              <FormControlLabel value="yes" control={<Radio size='small' />} label={<Typography>Yes</Typography>} />
              <FormControlLabel value="no" control={<Radio size='small' />} label={<Typography>No</Typography>} />
            </RadioGroup>
          </Box>
          <Typography className='eMed_refdoc_title' sx={{ mt: 1 }}>{"Upload Your Documents Here"}</Typography>
          <Box sx={{ marginTop: "0.75vw", minHeight: '5vw' }}>
            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
              <Box component={'input'} type='file' sx={{ display: 'none' }}
                multiple
                accept="image/jpg, image/jpeg, image/png,application/pdf"
                ref={uploadImage}
                onChange={onImageHandler}
              />
              <Box>
                {UploadButton(() => {
                  setImage((prev) => ({
                    ...prev,
                    imgCapClked: true,
                  }));
                }, ImagePaths.CameraCapture.default, "Capture Image")}
                {UploadButton(() => uploadImage.current.click(), ImagePaths.LabUploadButton.default, "Browse Files")}
              </Box>
            </Box>
            {Image.imageuploadList?.length > 0 && (
              <Box
                component={'div'}
                display={'flex'}
                maxWidth={'29vw'}
                alignItems={'center'}
                justifyContent={'center'}
                overflow={'scroll'}
              >
                {Image.imageuploadList.map((image, index) => (
                  <Box
                    component={'div'}
                    key={index}
                    mr={'0.5vw'}
                    height={'5vw'}
                    display={'flex'}
                    alignItems={'center'}
                  >
                    <Tooltip title={typeof image === 'string' ? '' : image?.name} arrow placement="top">
                      <Box
                        component={'img'}
                        onClick={() => {
                          if (typeof image === 'string') {
                            const ext = image.split('.').pop()?.toLowerCase();
                            if (['jpg', 'jpeg', 'png'].includes(ext)) {
                              setImage((prev) => ({
                                ...prev,
                                isImgClicked: true,
                                popUpOpen: true,
                                selectedImage: image,
                              }));
                            } else {
                              window.open(image);
                            }
                          }
                        }}
                        src={
                          typeof image === 'string'
                            ? ['jpg', 'jpeg', 'png'].includes(image.split('.').pop()?.toLowerCase())
                              ? image
                              : ImagePaths.DocumentPreview.default
                            : image?.type === 'image/jpeg' || image?.type === 'image/png'
                              ? ImagePaths.ImagePreview.default
                              : ImagePaths.DocumentPreview.default
                        }
                        height={'4vw'}
                        width={'3.5vw'}
                      />
                    </Tooltip>
                    <Box>
                      <IconButton
                        sx={{ position: 'relative', bottom: '1.2vw', right: '1.4vw' }}
                        size="small"
                        onClick={() => {
                          setImage((prev) => ({
                            ...prev,
                            selectedImage: null,
                          }));
                          onImageRemove(index); // You must define `onImageRemove` in your functional component
                        }}
                      >
                        <CancelTwoToneIcon fontSize="small" color="error" />
                      </IconButton>
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Box>

        <Box
          sx={{
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0.75dvw 0.5dvw',
            pt: 1,
            borderTop: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Button size='small' sx={{ textTransform: "capitalize" }} variant='outlined' onClick={() => {
            setselectedCategory(null);
            setselectedLocation(null);
            setDocuName('');
            setVisitDate(null);
            setmedicoLegel("no");
            setDocumentType(null)
            setSelectedIcd(null)
            setIcdCodeSearch('')
            setCodeICDapi([])
            setDocumentRemarks('')
            setImage(prev => ({
              ...prev,
              open: false,
              imageuploadList: [],
              imageViewerPopup: false,
              viewData: [],
              viewImage: null,
              selectedImage: null,
              imgCapClked: false,
              CapturedImg: null,
            }))
          }}>Clear</Button>
          <Button size='small' sx={{ textTransform: "capitalize", marginLeft: "1vw" }} disabled={!props?.Access?.editAccess} variant='contained' onClick={() => { postDocuments() }}>Add</Button>
        </Box>
      </Box>
    )
  }
  return (
    <Box component={"div"} className={'eMed_bill_container'}>
      <Box sx={{ height: '9.5dvh', padding: '0.5dvw' }}>
        <Box component={'div'} sx={{
          backgroundColor: 'white', borderRadius: '5px',
          boxShadow: '0px 0px 3px gray', width: '23vw', height: '3.5vw', padding: '0.2vw',
        }}>
          <CommonPatientDetails data={patientDetails} />
        </Box>
      </Box>
      <Grid container className={'eMed_bill_content'} >
        <Grid container className={'eMed_bill_content1'} spacing={1}>
          <Grid item xs={8}>
            <Paper sx={{ height: '70dvh' }}>
              {renderLeftSide()}
            </Paper>
          </Grid>
          <Grid item xs={4}>
            <Paper sx={{ height: '70dvh', padding: '0.5dvw', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxSizing: 'border-box' }}>
              {renderRightSide()}
            </Paper>
          </Grid>
        </Grid>
        {renderImageViewerPopup()}
      </Grid>
      {Image.imgCapClked && (
        <OpenWebCamPopUP
          capturedImg={Image.CapturedImg}
          closePopup={closeWebCamPop}
          addImgCapture={addImgCapture}
        />
      )}
      {isDelete ?
        <DeletePopup
          DeletTitle={`Are you sure you want to delete this document ?`}
          deleteAlertPopupClose={PopupClose.bind(this)}
          removeData={deletePatientDocument.bind(this)}
          ButtonText={'Yes'}
        />
        : null}
      {errorMsg ?
        <ToastMsg
          severity={'error'}
          msg={errorMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
      {successMsg ?
        <ToastMsg
          severity={'success'}
          msg={successMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
    </Box>
  )
}

export default MrdDocumentsAdd